module.exports = __webpack_public_path__ + "img/Dkterma-1138-655-303.652a28e9.jpg";